import {GetMessagingAdsListUserError} from '../Errors/GetMessagingAdsListUserError.js'

export class GetMessagingAdsListUserRequest {
  /**
   * @param {Array<string>} adIds
   */
  constructor({adIds}) {
    this._adIds = adIds || []
  }

  static validate({adIds}) {
    if (!Array.isArray(adIds) || adIds.length <= 0) {
      throw GetMessagingAdsListUserError.create({message: '[GetMessagingAdsListUser.validate] adsIds is required'})
    }
  }

  adIds() {
    return this._adIds
  }

  /**
   * Maps adIds array to query params string
   * @returns {string} Query string like "ids=123&ids=456&ids=789"
   */
  toQueryParams() {
    return this._adIds.map(adId => `ids=${adId}`).join('&')
  }

  static create = ({adIds}) => {
    GetMessagingAdsListUserRequest.validate({adIds})
    return new GetMessagingAdsListUserRequest({
      adIds
    })
  }

  toJSON() {
    return {
      adIds: this.adIds(),
      queryParams: this.toQueryParams()
    }
  }
}

export const factory = GetMessagingAdsListUserRequest.create
